import './index.css';

export default function Footer() {
  return (
    <div className='container-footer'>
      <p className='footer'>@ 2023 by  <a className='myName' href="https://www.linkedin.com/in/matheus-matos-1a523221b/">Matheus Matos</a></p>
    </div>
  )
}